import { render, staticRenderFns } from "./Guard.vue?vue&type=template&id=31c3835e&"
import script from "./Guard.vue?vue&type=script&lang=js&"
export * from "./Guard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports